<!-- 修改密码 -->

<template>
  <div class="c-passw-change">
    <ul class="c-profile-list">
          <li>
              <p class="c-profile-lf-txt"><em>*</em>设置密码 </p>
              <div class="c-profile-rt-input">
                  <input v-model="password" type="password" maxlength="16" placeholder="设置密码">
              </div>
          </li>
          <li>
              <p class="c-profile-lf-txt"><em>*</em>确定密码 </p>
              <div class="c-profile-rt-input">
                  <input v-model="confirmpassword" type="password" maxlength="16" placeholder="确认密码">
              </div>
          </li>
          <li>
              <p class="c-profile-lf-txt"><em>*</em>手机号 </p>
              <div class="c-profile-rt-input">
                 <input v-model="account" type="tel" maxlength="11" placeholder="请输入手机号">
              </div>
          </li>
          <li>
              <p class="c-profile-lf-txt"><em>*</em>手机验证码 </p>
              <div class="c-profile-rt-input" style="display: flex;">
                  <input v-model="verifycode" class="msg-code" type=" tel" maxlength="6" placeholder="验证码">
                  <span @click="getMsgCode" :class="{'msg-btn--grey': msgcodeSending}" class="msg-btn">{{msgbtnText}}</span>
              </div>
          </li>
      </ul>

      <div class="sbumit-btn-box">
          <button @click="changePassw" class="submit-btn">确定修改</button>
      </div>
  </div>
</template>
<script>
  import {
    setpasswordbyaccount,
    queryVerifycode
  } from '@/api/login';
import { getCacheUserInfo } from '@/utils/auth';
import { validMobile,validPassword } from '@/utils/validTools.js'
export default {
  name: 'PasswordChange',
  props: {
    msg: String,
  },
  data() {
    return {
      msgcodeSending: false,
      msgbtnText: '获取验证码',
      count: 0,
      verifycode: '',
      confirmpassword: '',
      password: '',
      account: '',
    }
  },
  mounted() {
  },
  methods: {
      changePassw() {
        const uid = getCacheUserInfo().uid;
        if (!this.password) {
            this.$message.error('请输入密码');
            return;
        }
        if(!validPassword(this.password)){
          this.$message.error('密码由字母和数字组合,长度控制在8-16位');
          return;
        }
        if (!this.confirmpassword) {
            this.$message.error('请输入确认密码');
            return;
        }
        if(this.password!=this.confirmpassword){
            this.$message.error('两次输入的密码不一样');
            return;
        }
        if (!this.account) {
            this.$message.error('请输入手机号');
            return;
        }
        if(!validMobile(this.account)){
          this.$message.error('请输入正确的手机号');
          return;
        }
        if (!this.verifycode) {
            this.$message.error('请输入短信验证码');
            return;
        }
        this.$http.post(setpasswordbyaccount(), {
            account: this.account,
            password: this.password,
            confirmpassword: this.confirmpassword,
            verifycode: this.verifycode
        }).then(res => {
            console.log('更改密码', res);
            if (res.code === 1) {
                this.$message.success('修改成功');
                return;
            }
            this.$message.error(res.msg || '服务器错误');
        }, err => {

        });
      },
      getMsgCode() {
          if (this.msgcodeSending) {
              return;
          }
          const mobile = this.account;
          if (!mobile) {
              this.$message.error('请输入手机号');
              return;
          }
          if(!validMobile(this.account)){
            this.$message.error('请输入正确的手机号');
            return;
          }

          this.msgcodeSending = true;
          this.$http.get(queryVerifycode(), {
              mobile
          }).then(res => {
              this.msgbtnText = '60秒后重新获取';
              this.count = 60;
              this.countDown();
              console.log(res);
          }).catch(() => {
              this.msgcodeSending = false;
          })
      },
      countDown() {
          if (this.count > 0) {
              setTimeout(() => {
                  this.count -= 1;
                  this.msgbtnText = `${this.count}秒后重新获取`;
                  this.countDown();
              }, 1000)
          } else {
              this.msgcodeSending = false;
              this.msgbtnText = '获取验证码';
          }
      },
  }
};
</script>

<style>
@import url(./main.css);

.c-passw-change {
    min-height: calc(100% - 2rem);
}
.msg-code {
    width: 2.21rem;
}
.msg-btn {
    width: 1.68rem;
    background-color: #1775F0;
    color: #fff;
    display: inline-block;
    text-align: center;
    min-height: calc(100% - 2rem);
    margin-left: .1rem;
    cursor: pointer;
}

.msg-btn.msg-btn--grey {
    background-color: #ccc;
}
</style>
